import { render } from "./toDoList.vue?vue&type=template&id=fbd0853e&scoped=true"
import script from "./toDoList.vue?vue&type=script&lang=js"
export * from "./toDoList.vue?vue&type=script&lang=js"

import "./toDoList.vue?vue&type=style&index=0&id=fbd0853e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd0853e"]])

export default __exports__